import { Component, OnInit } from '@angular/core';
import { CertificateService } from '../../../services/certificate.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { response } from 'express';
import { error } from 'console';
import { SubscriptionService } from '../../../services/subscription.service';
import { environment } from '../../../../environments/environment';
import { ChatService } from '../../../services/chat-service.service';
import { ToastService } from '../../../services/toast.service';

export interface Certificate {
  _id?: string;
  user_id: string;
  common_name: string;
  alternative_name?: string | null;
  certificate_authority: string;
  status: 1 | 2 | 3;
  expiry_date: Date;
  domain_url: string;
  ssl_type: 1 | 2 | 3;
  server_type: 1 | 2;
}

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.scss'],
})
export class CertificatesComponent {
  certificates: any[] = [];
  noCertificatesMessage: string =
    'No certificates available. Please add a new certificate.';
  filteredCertificates = [...this.certificates];
  newDomain = '';
  searchQuery: string = '';
  subscriptionPlan: any;
  rotateKeyCert: any;
  errMsg: any;
  isKeyRotation: boolean = false;

  existingChats: any[] = [];
  showResumeChatModal: boolean = false;
  isLoadingChats: boolean = false;

  constructor(
    private certificatesService: CertificateService,
    private subscriptionService: SubscriptionService,
    private chatService: ChatService,
    private router: Router,
    private toaster: ToastService,
    private userService: UserService
  ) { }

  async ngOnInit(): Promise<void> {
    // get the url and check if it has 'key-rotation'
    const currentUrl = this.router.url; // Gets the current URL
    console.log('Current URL:', currentUrl);
    this.isKeyRotation = currentUrl.includes('key-rotation');

    this.subscriptionPlan =
      await this.subscriptionService.getSubscriptionValue();
    console.log(
      'certificates.component.ts [f3caea] ngOnInit: ',
      this.subscriptionPlan
    );
    this.fetchCertificates();
    this.loadUserChats();
  }

  getStatus(certificate: any) {
    if (certificate?.certificate == null) {
      return certificate?.error;
    }
    if (certificate?.certificate?.valid_to)
      return new Date(certificate?.certificate?.valid_to) > new Date()
        ? 'Active'
        : 'Inactive';
    return 'Unknown';
  }
  showPopup(certification: any) { }
  // navigateToChatComponent(): void {
  //    if(this.subscriptionPlan != null) {
  //       const feature = this.subscriptionPlan?.subscription_plan?.features?.find(
  //         (item: any) => item.feature?.code === 'ssl'
  //       );
  //       console.log(
  //         'certificates.component.ts [20f529] feature: ',
  //         feature,
  //         feature && this.certificates.length >= feature.quantity,
  //         this.certificates.length
  //       );
  //       if (
  //         (feature && this.certificates.length >= feature.quantity) ||
  //         this.subscriptionPlan?.is_active != true
  //       ) {
  //         this.router.navigate(['/subscription'], {
  //           queryParams: { url: 'chat' },
  //         });
  //         return;
  //       }
  //    } else
  //   this.router.navigate(['/chat']);
  // }
  navigateToChatComponent(): void {
    if (this.subscriptionService.hasActiveSubscription()) {
      this.subscriptionPlan = this.subscriptionService.getSubscriptionValue();
      const feature = this.subscriptionPlan?.subscription_plan?.features?.find(
        (item: any) => item.feature?.code === 'ssl'
      );

      const planActive = this.subscriptionPlan?.is_active === true;
      const limitNotExceeded = feature
        ? this.certificates.length < feature.quantity
        : false;
      console.log(
        'certificates.component.ts [20f529] feature: ',
        feature,
        'Plan Active:',
        planActive,
        'Limit Not Exceeded:',
        limitNotExceeded,
        'Current Certificates Count:',
        this.certificates.length
      );
      if (planActive && limitNotExceeded) {
        this.chatService.initiateChat().subscribe({
          next: (response: any) => {
            console.log('Chat initiated successfully:', response);
            this.router.navigate(['/chat/' + response._id]);
          },
          error: (error) => {
            console.error('Error initiating chat:', error);
            this.errMsg = 'Failed to initiate chat. Please try again later.';
          },
        });
      } else {
        this.router.navigate(['/subscription'], {
          queryParams: { url: 'chat' },
        });
      }
    }
    else {
      this.router.navigate(['/subscription'], {
        queryParams: { url: 'chat' },
      });
    }

  }

  onSearchChange(): void {
    const lowerCaseQuery = this.searchQuery.toString().toLowerCase();
    this.filteredCertificates = this.certificates.filter((certificate) => {


      return (
        certificate.domain.toString().toLowerCase().includes(lowerCaseQuery) ||
        certificate.certificate.issuer.O.toString().toLowerCase().includes(lowerCaseQuery)
      );
    });
  }

  fetchCertificates(): void {
    this.certificatesService.getAllCertificates().subscribe({
      next: (response) => {
        this.certificates = response;
        this.filteredCertificates = [...this.certificates];
        console.log("fetched cert 111 -> ", response)
      },
      error: (error) => {
        console.error('Error fetching certificates:', error);
      },
    });
  }

  confirmRotateKeys(certificate: any) {
    if (this.subscriptionService.hasActiveSubscription()) {
      this.subscriptionPlan = this.subscriptionService.getSubscriptionValue();
      const feature = this.subscriptionPlan?.subscription_plan?.features?.find(
        (item: any) => item.feature?.code === 'ssl'
      );

      const planActive = this.subscriptionPlan?.is_active === true;
      const limitNotExceeded = feature
        ? this.certificates.length < feature.quantity
        : false;
      console.log(
        'certificates.component.ts [20f529] feature: ',
        feature,
        'Plan Active:',
        planActive,
        'Limit Not Exceeded:',
        limitNotExceeded,
        'Current Certificates Count:',
        this.certificates.length
      );
      if (planActive && limitNotExceeded) {
        this.rotateKeyCert = certificate;
        this.rotateKeys(this.rotateKeyCert?.domain, this.rotateKeyCert?._id);
      } else {
        this.router.navigate(['/subscription'], {
          queryParams: { url: 'chat' },
        });
      }
    }
    else {
      this.router.navigate(['/subscription'], {
        queryParams: { url: 'chat' },
      });
    }


  }

  rotateKeys(domain: string | undefined, certificateId: string | undefined) {
    if (this.rotateKeyCert != null) {
      this.closeRotateKeyModal();
      this.router.navigate(['/chat/rotate-keys'], {
        state: { data: { domain: domain, certificateId: certificateId } },
      });
      console.log('Rotating keys URL:', '/chat/rotate-keys');
      // this.certificatesService
      //   .getUserCertificateKeyRotation(this.rotateKeyCert?._id)
      //   .subscribe({
      //     next: (response) => {
      //       this.rotateKeyCert = null;
      //     },
      //     error: (error) => {
      //       console.error('Error rotating keys:', error);
      //       this.toaster.showToast('Error rotating keys', 'error');
      //       this.rotateKeyCert = null;
      //     },
      //   });
    }
  }
  closeRotateKeyModal() {
    this.rotateKeyCert = null;
  }

  // downloadCertificate(domain: string): void {
  //  const downloadUrl = `${environment.BACKEND_URL}/ssl-chat/webroot/download/${domain}`;

  //   const anchor = document.createElement('a');
  //   anchor.href = downloadUrl;
  //   anchor.setAttribute('download', '');
  //   anchor.click();
  // }

  loadUserChats(): void {
    this.isLoadingChats = true;
    this.chatService.getUserChats().subscribe({
      next: (chats) => {
        this.existingChats = chats ?? [];
        this.isLoadingChats = false;
      },
      error: () => {
        this.existingChats = [];
        this.isLoadingChats = false;
      },
    });
  }

  openResumeChatModal(): void {
    this.showResumeChatModal = true;
  }

  closeResumeChatModal(): void {
    this.showResumeChatModal = false;
  }

  resumeChat(chat: any): void {
    this.closeResumeChatModal();
    this.router.navigate(['/chat', chat._id]);
  }

  getChatPreview(chat: any): string {
    const last = chat.lastMessage || chat.last_message || '';
    return last.length > 60 ? last.slice(0, 60) + '…' : last;
  }

  downloadCertificate(cert: any): void {
    // const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = cert?.url;
    anchor.download = cert.name;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}
